"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatementPanelOptsSchema = void 0;
const zod_1 = require("zod");
exports.StatementPanelOptsSchema = zod_1.z.record(zod_1.z.any().refine(val => !Number.isNaN(Number(val))).transform(val => Number(val)), zod_1.z.object({ visible: zod_1.z.boolean() }));
